export function getGoogleCareerPathUrl(slug?: string) {
    return slug ? `/partner/google/${slug}` : undefined;
}
